import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';



@Component({
    selector : 'sittable-action',
    templateUrl:'sittableAction.html'
})
export class SittableActionComponent extends BaseActionComponent{

  public level=1;
  public linkForm: FormGroup;
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public processData(action){
    if (!action){
      action={kind:'sittable',param:{dx:0,dy:0,dz:0}}
    }
    let linkParam = this.linkForm['_value'];
    action.param=linkParam
  }
  public selectItem(item) {
  }  
  public reloadLocalPacks(){
    let list=[]
  }

  public childrenReloadData(){
    if (this.action.param){
      this.linkForm = this.fb.group({
        dx: this.action.param.dx,
        dy: this.action.param.dy,
        dz: this.action.param.dz
      });
    }else{
      this.linkForm = this.fb.group({
        dx: 0,
        dy: 0,
        dz: 0
      });
    }
    this.reloadLocalPacks();
 

  }

    public ngOnInit(): any {
      this.linkForm = this.fb.group({
        dx: 0,
        dy: 0,
        dz:0
      });


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/sittableAction.ts